import { useEffect, useState } from 'react';

export const getBatterHand = (filter) => (Number(filter.batterHand) === 1 ? 1 : 2);

const HAND_TRANSITION_DURATION = 100;

export const useHandFilterTransition = (filter) => {
    const [displayedHands, setDisplayedHands] = useState({
        batterHand: filter.batterHand,
        pitcherHand: filter.pitcherHand,
    });
    const isUpdating = displayedHands.batterHand !== filter.batterHand
        || displayedHands.pitcherHand !== filter.pitcherHand;

    useEffect(() => {
        if (!isUpdating) return undefined;

        const timeoutId = setTimeout(() => {
            setDisplayedHands({
                batterHand: filter.batterHand,
                pitcherHand: filter.pitcherHand,
            });
        }, HAND_TRANSITION_DURATION);

        return () => clearTimeout(timeoutId);
    }, [filter.batterHand, filter.pitcherHand, isUpdating]);

    return {
        chartFilter: isUpdating ? { ...filter, ...displayedHands } : filter,
        isUpdating,
    };
};

const toBool = (value) => value === true || value === 1 || value === '1' || value === 'true' || value === 'True';

export const matchesBool = (value, expected, allowMissing = false) => {
    if (expected === null || expected === undefined) {
        return value === null || value === undefined;
    }
    if (value === null || value === undefined) {
        return allowMissing;
    }
    return toBool(value) === expected;
};
